var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1589 7.68598H13.5954L14.4709 6.46527C14.6188 6.25565 14.701 6.00493 14.701 5.74599V3.40732C14.701 1.52898 13.1721 0 11.2937 0C9.41537 0 7.88639 1.52898 7.88639 3.40732V4.71023L4.12561 9.22729C3.94065 9.44924 3.83789 9.72873 3.83789 10.0164V18.767C3.83789 19.4492 4.38865 20 5.07094 20H13.4639C13.657 20 13.8461 19.9548 14.0187 19.8685L17.7138 18.0066C18.1289 17.797 18.3919 17.3695 18.3919 16.9051V8.91903C18.3919 8.23674 17.8412 7.68598 17.1589 7.68598ZM15.9258 16.1447L13.172 17.5298H6.30398V10.4562L10.0648 5.93917C10.2497 5.71722 10.3525 5.43773 10.3525 5.15002V3.3991C10.3525 2.88122 10.7758 2.45787 11.2937 2.45787C11.8116 2.45787 12.2349 2.88122 12.2349 3.3991V5.3432L10.1963 8.19564C9.92914 8.56967 9.89214 9.067 10.1018 9.47801C10.3114 9.88903 10.7347 10.148 11.1992 10.148H15.9258V16.1406V16.1447Z",
    fill: "#ba120e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.46254 9.22314C0.780253 9.22314 0.229492 9.7739 0.229492 10.4562V18.7628C0.229492 19.4451 0.780253 19.9959 1.46254 19.9959C2.14482 19.9959 2.69558 19.4451 2.69558 18.7628V10.4562C2.69558 9.7739 2.14482 9.22314 1.46254 9.22314Z",
    fill: "#ba120e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.4b3d8862d6a54eda20e9689e1d17663f.svg";
export { ForwardRef as ReactComponent };